import { digObject } from '@domain-group/javascript-utils'
import {
  faAtlas, faDatabase, faGlobe, faHome, faTachometer, faUsers,
} from '@fortawesome/pro-light-svg-icons'

const propertyDetailsTabBarItems = (campaignId: number, campaignPermissions: object = {}) => [
  {
    hidden: !digObject(campaignPermissions, 'details.manage', false),
    href: `#/campaigns/${campaignId}/edit/details`,
    icon: faTachometer,
    key: 'details',
    title: 'Details',
  },
  {
    hidden: !digObject(campaignPermissions, 'contacts.manage', false),
    href: `#/campaigns/${campaignId}/edit/contacts`,
    icon: faUsers,
    key: 'contacts',
    title: 'Contacts',
  },
  {
    hidden: !digObject(campaignPermissions, 'details.manage', false),
    href: `#/campaigns/${campaignId}/edit/data-store`,
    icon: faDatabase,
    key: 'data-store',
    title: 'Data Store',
  },
  {
    hidden: !digObject(campaignPermissions, 'proposals.manage', false),
    href: `#/campaigns/${campaignId}/edit/comparables`,
    icon: faHome,
    key: 'comparables',
    title: 'Comparables',
  },
  {
    hidden: !digObject(campaignPermissions, 'portals.manage', false),
    href: `#/campaigns/${campaignId}/edit/portals`,
    icon: faGlobe,
    key: 'portals',
    title: 'Portals',
  },
  {
    hidden: !digObject(campaignPermissions, 'portals.manage', false),
    href: `#/campaigns/${campaignId}/edit/portal-data`,
    icon: faAtlas,
    key: 'portal-data',
    title: 'Portal Data',
  },
]
export default propertyDetailsTabBarItems
